module.exports = __webpack_public_path__ + "img/INTERIOR-VITARA-4.5df1c73c.jpg";